export default __webpack_public_path__ + "static/media/MarvelousMotion_09.88544350.png";